import { Link, useLocation } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-[60vh] flex-col items-start justify-center" data-testid="not-found-page">
      <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-red/10 text-brand-red">
        <Compass className="h-5 w-5" />
      </div>
      <p className="mt-5 font-heading text-4xl font-extrabold tracking-tight text-brand-ink sm:text-5xl">
        Off the map.
      </p>
      <p className="mt-2 max-w-xl text-base text-brand-mute">
        Nothing lives at <code className="rounded bg-slate-100 px-1.5 py-0.5 text-sm">{pathname}</code>.
        Pick a stop from the sidebar, or head back to the war room.
      </p>
      <Button asChild className="mt-6 bg-brand-red text-white hover:bg-brand-redhover" data-testid="not-found-home-btn">
        <Link to="/"><ArrowLeft className="mr-2 h-4 w-4" /> Back to dashboard</Link>
      </Button>
    </div>
  );
}
